import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grow } from '@mui/material';

import "./CustomModal.css";

import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";




interface ButtonInterface{

  label:string;

  onClick:()=>void;

}

interface ModalProps {

  open: boolean;



  heading?: string;

  children: React.ReactNode;

  SignOutButton:ButtonInterface;

}




export const SessionExpiredModal: React.FC<ModalProps> = ({ open,heading, children,SignOutButton}) => {

  return (

    <StyledEngineProvider injectFirst>

      <Dialog

          maxWidth='xs'

          fullWidth

          open={open}

         

          disableEscapeKeyDown={true}

          TransitionComponent={Grow}

          aria-labelledby="modal-title"

          aria-describedby="modal-description">

          {

            heading &&

            <DialogTitle id="modal-title" className='DialogTitle'>{heading}</DialogTitle>

          }

          <DialogContent>

              {children}

          </DialogContent>

          <DialogActions>

              <Button variant='outlined' onClick={SignOutButton.onClick} className='Button'>{SignOutButton.label}</Button>


          </DialogActions>

      </Dialog>

    </StyledEngineProvider>

  );

};